import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-editbuttonrender',
  templateUrl: './editbuttonrender.component.html',
  styleUrls: ['./editbuttonrender.component.scss']
})
export class EditbuttonrenderComponent implements ICellRendererAngularComp, OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  refresh(params: ICellRendererParams): boolean {
    throw new Error("Method not implemented.");
}
afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
}
private params: any;

agInit(params: any): void {
  this.params = params;
 
}

btnClickedHandler(event) {
  this.params.clicked(this.params);
}

ngOnDestroy() {
  // no need to remove the button click handler 
  // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
}

}
